/*
 * 5-М3 «Карточка записи» глазами мастера. Размеры из макета «Мастер - П0»:
 * время 24/600 табличными цифрами, имя 19/600, подписи 12, услуги в рамке radius 12,
 * кнопки подвала 48 px, «Не пришёл…» отдельной строкой 44 px.
 */

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-1) var(--space-4) var(--space-2);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.missing {
  margin: var(--space-4);
}

.time {
  margin: 0;
  font-size: 24px;
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.sub {
  margin: 0;
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.4;
}

.client {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
}

.note {
  margin: 0;
  background: var(--master-note-bg);
  color: var(--master-note-fg);
  border-radius: var(--radius-lg);
  padding: 8px 12px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: 1.4;
}

/* ─────────── телефон ─────────── */

.phoneRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--bg-card);
}

.phone {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.callLink {
  margin-left: auto;
  flex: none;
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 var(--space-4);
  border-radius: var(--radius-lg);
  background: var(--accent);
  color: var(--text-on-accent);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  text-decoration: none;
}

.callLink:focus-visible {
  outline: var(--focus-ring-width) solid var(--focus-ring-color);
  outline-offset: var(--focus-ring-offset);
}

/* ─────────── услуги ─────────── */

.caption {
  margin: 0 0 6px;
  font-size: var(--font-size-xs-plus);
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: var(--font-weight-semibold);
}

.services {
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  background: var(--bg-card);
}

.serviceRow {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
}

.serviceRow:last-child {
  border-bottom: 0;
}

.serviceName {
  margin: 0;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-base);
}

.serviceDuration {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

.servicePrice {
  font-variant-numeric: tabular-nums;
  font-weight: var(--font-weight-semibold);
  white-space: nowrap;
}

.totalRow {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
  padding: 10px 12px;
  background: var(--bg-sunken);
  font-variant-numeric: tabular-nums;
}

.totalLabel {
  color: var(--text-secondary);
  font-size: var(--font-size-md);
}

.totalValue {
  font-weight: var(--font-weight-semibold);
}

.comment {
  margin: 0;
  font-size: var(--font-size-base);
  line-height: 1.45;
}

/* ─────────── второстепенные действия ─────────── */

.secondaryRow {
  display: flex;
  gap: var(--space-2);
}

.secondaryButton {
  flex: 1;
  height: 44px;
  border-radius: var(--radius-lg);
}

.explain {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.45;
}

.problem {
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-lg);
  background: var(--status-no-show-bg);
  color: var(--status-no-show-fg);
  font-size: var(--font-size-md);
  line-height: 1.4;
}

/* ─────────── подвал ─────────── */

.footer {
  flex: none;
  border-top: 1px solid var(--border);
  padding: var(--space-2) var(--space-4) var(--space-3);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.footerRow {
  display: flex;
  gap: var(--space-2);
}

.footerButton {
  flex: 1;
  height: var(--touch-min-target);
  font-size: var(--font-size-base);
  border-radius: 12px;
}

/* «Не пришёл…» отделён от безопасной пары: собственная строка, ghost-начертание
   и подтверждение вторым шагом. Промах пальцем не должен ставить человеку неявку. */
.noShowButton {
  height: 44px;
  border-radius: 12px;
  font-size: var(--font-size-base);
}

.noShowBox {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border: 1px solid var(--border-strong);
  border-radius: 12px;
  padding: var(--space-3);
  background: var(--bg-card);
}

.noShowLabel {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.noShowInput {
  min-height: 64px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-strong);
  background: var(--bg-workspace);
  color: var(--text-primary);
  font: inherit;
  font-size: var(--font-size-base);
  padding: 10px 12px;
  resize: vertical;
}

.noShowInput:focus-visible {
  outline: none;
  border-color: var(--accent);
  box-shadow: var(--field-focus-ring);
}

.noShowHint {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: 1.4;
}

.noShowActions {
  display: flex;
  gap: var(--space-2);
}
